import { durationToTime } from 'utils/date';

const parseDefaultValues = (pathway: Pathway) => {
  const result: Partial<Pathway> = { ...pathway };
  result.duration = durationToTime(Number(pathway?.duration));

  result.pathwayPoints = (pathway?.pathwayPoints ?? []).map((point) => ({
    id: point.id,
    position: point.position,
    attractionId: point?.attraction?.id,
  }));

  result.pathwayPointsAttributes = (pathway?.pathwayPoints ?? [])
    .map((point) => point?.attraction?.id)
    .filter((id): id is number => id !== undefined);

  return result;
};

export default parseDefaultValues;
